//export const API_URL = "http://localhost/api"
export const API_URL = "https://api.clgranada.com/api"